var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "db relative w-100 aspect-ratio--16x9" }, [
    _c("iframe", {
      staticClass: "dib w-100 aspect-ratio--object",
      attrs: {
        src:
          "https://player.vimeo.com/video/" +
          _vm.vimeoVideoId +
          "?autoplay=1&loop=1&autopause=0&muted=1&background=1",
        width: "100%",
        height: "640",
        frameborder: "0",
        webkitallowfullscreen: "",
        mozallowfullscreen: "",
        allowfullscreen: "",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }